class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.onCartUpdated = this.onCartUpdated.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.countRequest = 0;
  }

  connectedCallback() {
    CartAPI.subscribe(this.onCartUpdated);
    
    // Use event delegation for buttons since innerHTML gets replaced
    this.addEventListener('click', (event) => {
      const quantityBtn = event.target.closest('.quantity-selector__button');
      if (quantityBtn) {
        event.preventDefault();
        this.handleQuantityChange(quantityBtn);
      }

      const removeBtn = event.target.closest('cart-remove-button button');
      if (removeBtn) {
        event.preventDefault();
        this.handleRemove(removeBtn.closest('cart-remove-button'));
      }
      
      const closeBtn = event.target.closest('.drawer__close');
      if (closeBtn) {
        const drawer = this.closest('es-drawer');
        if (drawer) drawer.close();
      }
    });

    this.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('.quantity-selector__input');
      if (quantityInput) {
        this.updateQuantity(quantityInput.dataset.line, quantityInput.value);
      }
    });
  }

  disconnectedCallback() {
    const index = CartAPI.listeners.indexOf(this.onCartUpdated);
    if (index > -1) CartAPI.listeners.splice(index, 1);
  }

  handleQuantityChange(button) {
    const input = button.parentElement.querySelector('.quantity-selector__input');
    const currentValue = parseInt(input.value || 0, 10);
    const line = input.dataset.line;
    const newValue = button.name === 'plus' ? currentValue + 1 : currentValue - 1;

    if (newValue < 0) return;
    input.value = newValue;
    this.updateQuantity(line, newValue);
  }

  handleRemove(removeComponent) {
    const line = removeComponent.dataset.line;
    this.updateQuantity(line, 0);
  }

  async updateQuantity(line, quantity) {
    this.setAttribute('aria-busy', 'true');
    this.classList.add('is-loading');

    try {
      await CartAPI.changeLineItem(line, quantity, ['cart-drawer', 'cart-icon-bubble']);
    } catch (error) {
      console.error('Failed to update cart', error);
    } finally {
      this.removeAttribute('aria-busy');
      this.classList.remove('is-loading');
    }
  }

  onCartUpdated(state) {
    if (state.sections) {
      if (state.sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        const newContent = html.getElementById('cart-drawer-content');
        if (newContent) {
          this.innerHTML = newContent.innerHTML;
        }
      }
      
      this.updateCount(state);
    }
  }

  /* Header cart count. change.js / update.js answer with the cart, so item_count is used as is. add.js answers with
     the added item only: writing its missing item_count emptied the badge, and the cart-icon-bubble section bundled
     with it was seen on a live store still showing the count from before the add. So after an add the count is read
     from the cart itself (cart.js). Only the newest request may write, so quick successive adds cannot leave an
     older answer on screen. */
  async updateCount(state) {
    const request = ++this.countRequest;
    let count = Number.isInteger(state.item_count) ? state.item_count : null;

    if (count === null) {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        if (Number.isInteger(cart.item_count)) count = cart.item_count;
      } catch (error) {
        return;
      }
    }

    if (count === null || request !== this.countRequest) return;
    document.querySelectorAll('.header__cart-count').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

/* Guarded like every other definition in the theme: an unguarded define() throws
   NotSupportedError if this file is ever evaluated twice, which aborts the rest of the script. */
class CartQuantity extends HTMLElement {}
if (!customElements.get('cart-quantity')) {
  customElements.define('cart-quantity', CartQuantity);
}

class CartRemoveButton extends HTMLElement {}
if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}
